import React from 'react'
import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'

const FontAlign = props => {
  const { align, onChange } = props

  return (
    <div
      className={styles['wrapper-text-align'] + ' ba-pd-x-1'}
    >
      <span
        onClick={() => onChange({ textAlign: 'left' })}
        aria-hidden={true}
      >
        <IconComponent
          icon="text-align-left"
          fill={align === 'left' && '#0F7BFF'}
        />
      </span>
      <span
        onClick={() => onChange({ textAlign: 'center' })}
        aria-hidden={true}
      >
        <IconComponent
          icon="text-align-center"
          fill={align === 'center' && '#0F7BFF'}
        />
      </span>
      <span
        onClick={() => onChange({ textAlign: 'right' })}
        aria-hidden={true}
      >
        <IconComponent
          icon="text-align-right"
          fill={align === 'right' && '#0F7BFF'}
        />
      </span>

    </div>
  )
}

export default FontAlign


// WEBPACK FOOTER //
// ./src/components/editors/FontAlign/index.js